<template>
  <article
    role="404"
    v-observe-visibility="visibilityChanged"
    :class="[{ 'show-up': isVisible }, baseAnimation]"
    id="page404"
  >
    <PageLogo type="dark" />
    <div class="container page_404">
      <div class="no-found-icon">
        <svg
          width="445px"
          height="381px"
          viewBox="0 0 445 381"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Page-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g id="221511-P1BAI4-59" transform="translate(2.000000, 0.000000)">
              <path
                d="M61.719,1.269 L412.617,0.334605165 L384.458,367.474 L88.024,367.474 C86.849,363.18 62.592,-21.031 61.719,1.269 Z"
                id="Fill-4"
                fill="#FFF0F6"
              ></path>
              <polyline
                id="Fill-5"
                fill="#DABCD0"
                points="84.04 340.113 109.699 322.492 370.207 328.603 370.207 342.186 308.537 342.186 325.957 380.257 320.125 376.046 282.005 351.374 201.217 347.653 165.686 380.257 184.138 351.451 84.04 340.113"
              ></polyline>
              <path
                d="M187.603,334.714 C187.603,334.714 166.865,373.973 166.932,373.282 C166.999,372.591 171.518,376.046 171.518,376.046 L199.361,334.714 L187.603,334.714"
                id="Fill-6"
                fill="#828282"
              ></path>
              <path
                d="M156.34,375.112 L150.445,360.068 C148.602,355.362 151.335,350.111 156.248,348.922 L160.517,347.89 C165.432,346.701 170.265,350.124 170.773,355.155 L172.398,371.232 C172.832,375.524 169.921,379.438 165.686,380.257 C161.738,381.02 157.807,378.857 156.34,375.112"
                id="Fill-7"
                fill="#828282"
              ></path>
              <path
                d="M304.04,334.714 C304.04,334.714 324.778,373.973 324.711,373.282 C324.645,372.591 320.125,376.046 320.125,376.046 L292.282,334.714 L304.04,334.714"
                id="Fill-8"
                fill="#828282"
              ></path>
              <path
                d="M335.303,375.112 L341.198,360.068 C343.042,355.362 340.308,350.111 335.395,348.922 L331.126,347.89 C326.211,346.701 321.379,350.124 320.87,355.155 L319.245,371.232 C318.811,375.524 321.722,379.438 325.957,380.257 C329.905,381.02 333.836,378.857 335.303,375.112"
                id="Fill-9"
                fill="#828282"
              ></path>
              <polyline
                id="Fill-10"
                fill="#828282"
                points="133.249 252.271 86.149 244.941 86.149 248.606 133.249 264.1 133.249 252.271"
              ></polyline>
              <path
                d="M369.614,210.661 C364.393,210.419 360.321,205.949 360.563,200.729 L360.868,194.171 C361.111,188.951 365.58,184.878 370.8,185.121 C376.021,185.363 380.093,189.833 379.851,195.053 L379.546,201.611 C379.303,206.831 374.834,210.904 369.614,210.661"
                id="Fill-11"
                fill="#828282"
              ></path>
              <path
                d="M358.304,245.587 L370.634,237.722 C377.542,233.316 379.806,224.283 375.794,217.14 L368.008,203.279 L373.961,203.279 L386.577,217.558 C392.473,224.23 391.519,234.494 384.494,239.966 L364.978,255.167 L358.304,245.587"
                id="Fill-12"
                fill="#828282"
              ></path>
              <polyline
                id="Fill-13"
                fill="#FFFFFF"
                points="133.376 334.714 123.732 159.072 370.207 159.072 359.949 334.714 133.376 334.714"
              ></polyline>
              <polygon
                id="Stroke-14"
                stroke="#828282"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
                points="133.376 334.714 123.732 159.072 370.207 159.072 359.949 334.714"
              ></polygon>
              <polyline
                id="Fill-15"
                fill="#FFF0F6"
                points="308.537 194.675 350.706 194.675 351.099 197.129 308.537 197.457 308.537 194.675"
              ></polyline>
              <polyline
                id="Fill-16"
                fill="#FFF0F6"
                points="308.537 202.449 350.706 202.449 351.099 204.903 308.537 205.231 308.537 202.449"
              ></polyline>
              <polyline
                id="Fill-17"
                fill="#FFF0F6"
                points="308.537 210.223 350.706 210.223 351.099 212.677 308.537 213.005 308.537 210.223"
              ></polyline>
              <polyline
                id="Fill-18"
                fill="#FFF0F6"
                points="308.537 217.997 340.167 217.997 340.462 220.451 308.537 220.779 308.537 217.997"
              ></polyline>
              <path
                d="M131.937,188.021 L153.629,302.195 C155.154,310.22 161.902,316.205 170.051,316.76 L348.605,328.93 L139.281,328.93 L131.937,188.021"
                id="Fill-19"
                fill="#FBF1F5"
              ></path>
              <polyline
                id="Fill-20"
                fill="#FFD0E3"
                points="123.732 159.072 125.926 180.563 367.684 180.563 370.207 159.072 123.732 159.072"
              ></polyline>
              <polygon
                id="Stroke-21"
                stroke="#828282"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
                points="123.732 159.072 125.926 180.563 367.684 180.563 370.207 159.072"
              ></polygon>
              <polyline
                id="Fill-22"
                fill="#DABCD0"
                points="133.249 169.708 306.355 173.351 305.318 176.458 131.937 176.458 133.249 169.708"
              ></polyline>
              <path
                d="M327.562,169.708 C327.562,172.291 325.468,174.384 322.886,174.384 C320.303,174.384 318.209,172.291 318.209,169.708 C318.209,167.125 320.303,165.032 322.886,165.032 C325.468,165.032 327.562,167.125 327.562,169.708"
                id="Fill-23"
                fill="#FFFFFF"
              ></path>
              <path
                d="M342.76,169.708 C342.76,172.291 340.666,174.384 338.084,174.384 C335.501,174.384 333.407,172.291 333.407,169.708 C333.407,167.125 335.501,165.032 338.084,165.032 C340.666,165.032 342.76,167.125 342.76,169.708"
                id="Fill-24"
                fill="#FFFFFF"
              ></path>
              <path
                d="M357.958,169.708 C357.958,172.291 355.864,174.384 353.282,174.384 C350.699,174.384 348.605,172.291 348.605,169.708 C348.605,167.125 350.699,165.032 353.282,165.032 C355.864,165.032 357.958,167.125 357.958,169.708"
                id="Fill-25"
                fill="#FFFFFF"
              ></path>
              <path
                d="M180.424,217.897 L216.485,245.977 M216.485,217.897 L180.424,245.977 M272.367,219.066 L308.428,247.146 M308.428,219.066 L272.367,247.146 M212.499,291.471 C232.131,271.839 263.961,271.839 283.592,291.471"
                id="Stroke-26"
                stroke="#828282"
                stroke-width="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <g id="sign" transform="translate(0.000000, 20.000000)">
                <polyline
                  id="Fill-27"
                  fill="#FFFFFF"
                  points="70.031 90.412 88.395 290.399 98.049 290.182 75.19 90.046 70.031 90.412"
                ></polyline>
                <polygon
                  id="Stroke-28"
                  stroke="#828282"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  points="70.031 90.412 88.395 290.399 98.049 290.182 75.19 90.046"
                ></polygon>
                <path
                  d="M86.765,241.883 C81.544,241.641 77.472,237.171 77.714,231.951 L78.019,225.393 C78.262,220.173 82.731,216.1 87.951,216.343 C93.172,216.585 97.244,221.055 97.002,226.275 L96.697,232.833 C96.454,238.053 91.985,242.126 86.765,241.883"
                  id="Fill-29"
                  fill="#828282"
                ></path>
                <polyline
                  id="Fill-30"
                  fill="#EF8B8E"
                  points="49.371 140.082 5.936 104.975 0.047 49.438 35.154 6.003 90.692 0.114 134.127 35.221 140.015 90.758 104.909 134.193 49.371 140.082"
                ></polyline>
                <polygon
                  id="Stroke-31"
                  stroke="#828282"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  points="49.371 140.082 5.936 104.975 0.047 49.438 35.154 6.003 90.692 0.114 134.127 35.221 140.015 90.758 104.909 134.193"
                ></polygon>
                <path
                  d="M16.2518858,87.2212998 L16.2518858,78.2227598 L34.2489658,35.6596656 L45.0472138,35.6596656 L45.0472138,78.2227598 L49.7264546,78.2227598 L49.7264546,87.2212998 L45.0472138,87.2212998 L45.0472138,98.6494456 L35.1488198,98.6494456 L35.1488198,87.2212998 L16.2518858,87.2212998 Z M25.3404112,78.2227598 L35.1488198,78.2227598 L35.1488198,54.9165412 L25.3404112,78.2227598 Z M53.470456,83.5318984 L53.470456,50.7772128 C53.470456,40.6088626 58.7795946,34.9397824 68.4980178,34.9397824 C78.216441,34.9397824 83.5255796,40.6088626 83.5255796,50.7772128 L83.5255796,83.5318984 C83.5255796,93.7002486 78.216441,99.3693288 68.4980178,99.3693288 C58.7795946,99.3693288 53.470456,93.7002486 53.470456,83.5318984 Z M63.36885,50.147315 L63.36885,84.1617962 C63.36885,88.7510516 65.3485288,90.3707888 68.4980178,90.3707888 C71.6475068,90.3707888 73.6271856,88.7510516 73.6271856,84.1617962 L73.6271856,50.147315 C73.6271856,45.5580596 71.6475068,43.9383224 68.4980178,43.9383224 C65.3485288,43.9383224 63.36885,45.5580596 63.36885,50.147315 Z M87.6295226,87.2212998 L87.6295226,78.2227598 L105.626603,35.6596656 L116.424851,35.6596656 L116.424851,78.2227598 L121.104091,78.2227598 L121.104091,87.2212998 L116.424851,87.2212998 L116.424851,98.6494456 L106.526457,98.6494456 L106.526457,87.2212998 L87.6295226,87.2212998 Z M96.718048,78.2227598 L106.526457,78.2227598 L106.526457,54.9165412 L96.718048,78.2227598 Z"
                  id="404"
                  fill="#FFFFFF"
                  transform="translate(68.677989, 67.154556) rotate(-7.000000) translate(-68.677989, -67.154556) "
                ></path>
              </g>
              <polyline
                id="Fill-32"
                fill="#EF8B8E"
                points="441.08 52.499 235.087 46.742 237.22 145.87 278.074 147.152 275.228 173.351 312.776 151.086 316.776 148.367 431.575 151.97 441.08 52.499"
              ></polyline>
              <polygon
                id="Stroke-33"
                stroke="#828282"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
                points="441.08 52.499 235.087 46.742 237.22 145.87 278.074 147.152 275.228 173.351 312.776 151.086 316.776 148.367 431.575 151.97"
              ></polygon>
              <g
                id="chat"
                transform="translate(333.349683, 94.636873) rotate(2.000000) translate(-333.349683, -94.636873) translate(251.349683, 60.636873)"
                fill="#FFFFFF"
              >
                <path
                  d="M0.9205574,22.0111728 L0.9205574,11.2020472 C0.9205574,7.846467 2.672586,5.9756568 5.8796892,5.9756568 C9.0867924,5.9756568 10.838821,7.846467 10.838821,11.2020472 L10.838821,22.0111728 C10.838821,25.366753 9.0867924,27.2375632 5.8796892,27.2375632 C2.672586,27.2375632 0.9205574,25.366753 0.9205574,22.0111728 Z M4.1870514,10.9941794 L4.1870514,22.2190406 C4.1870514,23.733506 4.8403502,24.2680232 5.8796892,24.2680232 C6.9190282,24.2680232 7.572327,23.733506 7.572327,22.2190406 L7.572327,10.9941794 C7.572327,9.479714 6.9190282,8.9451968 5.8796892,8.9451968 C4.8403502,8.9451968 4.1870514,9.479714 4.1870514,10.9941794 Z M12.6792358,22.0111728 L12.6792358,11.2020472 C12.6792358,7.846467 14.4312644,5.9756568 17.6383676,5.9756568 C20.8454708,5.9756568 22.5974994,7.846467 22.5974994,11.2020472 L22.5974994,22.0111728 C22.5974994,25.366753 20.8454708,27.2375632 17.6383676,27.2375632 C14.4312644,27.2375632 12.6792358,25.366753 12.6792358,22.0111728 Z M15.9457298,10.9941794 L15.9457298,22.2190406 C15.9457298,23.733506 16.5990286,24.2680232 17.6383676,24.2680232 C18.6777066,24.2680232 19.3310054,23.733506 19.3310054,22.2190406 L19.3310054,10.9941794 C19.3310054,9.479714 18.6777066,8.9451968 17.6383676,8.9451968 C16.5990286,8.9451968 15.9457298,9.479714 15.9457298,10.9941794 Z M24.7051728,6.21322 L29.5158276,6.21322 C32.812017,6.21322 34.3858732,7.994944 34.3858732,11.3505242 L34.3858732,14.0528056 C34.3858732,17.4083858 32.812017,19.1901098 29.5158276,19.1901098 L27.9716668,19.1901098 L27.9716668,27 L24.7051728,27 L24.7051728,6.21322 Z M29.5158276,9.18276 L27.9716668,9.18276 L27.9716668,16.2205698 L29.5158276,16.2205698 C30.5551666,16.2205698 31.1193792,15.7751388 31.1193792,14.2606734 L31.1193792,11.1426564 C31.1193792,9.628191 30.5551666,9.18276 29.5158276,9.18276 Z M35.483903,11.2020472 C35.483903,7.846467 37.0874546,5.9756568 40.2945578,5.9756568 C43.501661,5.9756568 45.1052126,7.846467 45.1052126,11.2020472 L45.1052126,11.855346 L42.016891,11.855346 L42.016891,10.9941794 C42.016891,9.479714 41.422983,8.9451968 40.383644,8.9451968 C39.344305,8.9451968 38.750397,9.479714 38.750397,10.9941794 C38.750397,12.4195586 39.4630866,13.4588976 40.4133394,14.4091504 C40.8884658,14.9139722 41.3932876,15.3890986 41.9575002,15.864225 C43.0265346,16.8441732 44.0361782,17.9725984 44.6597816,19.427673 C44.986431,20.170058 45.134908,21.0312246 45.134908,22.0111728 C45.134908,25.366753 43.4719656,27.2375632 40.2648624,27.2375632 C37.0577592,27.2375632 35.3948168,25.366753 35.3948168,22.0111728 L35.3948168,20.7342706 L38.4831384,20.7342706 L38.4831384,22.2190406 C38.4831384,23.733506 39.1364372,24.2383278 40.1757762,24.2383278 C41.2151152,24.2383278 41.868414,23.733506 41.868414,22.2190406 C41.868414,20.7936614 41.1557244,19.7543224 40.2054716,18.7743742 C39.7303452,18.2992478 39.2255234,17.8241214 38.6910062,17.3192996 C37.5922764,16.3690468 36.5826328,15.2406216 35.9590294,13.785547 C35.63238,13.043162 35.483903,12.1819954 35.483903,11.2020472 Z M46.8565412,23.8522876 L50.0042536,23.8522876 L50.0042536,27 L46.8565412,27 L46.8565412,23.8522876 Z M52.3791856,23.8522876 L55.526898,23.8522876 L55.526898,27 L52.3791856,27 L52.3791856,23.8522876 Z"
                  id="Oops.."
                ></path>
                <path
                  d="M0.893998993,50.1343817 C0.893998993,46.5522817 2.60579899,44.5551817 6.02939899,44.5551817 C9.45299899,44.5551817 11.164799,46.5522817 11.164799,50.1343817 L11.164799,50.8317817 L7.86799899,50.8317817 L7.86799899,49.9124817 C7.86799899,48.2957817 7.23399899,47.7251817 6.12449899,47.7251817 C5.01499899,47.7251817 4.38099899,48.2957817 4.38099899,49.9124817 C4.38099899,51.4340817 5.14179899,52.5435817 6.15619899,53.5579817 C6.66339899,54.0968817 7.20229899,54.6040817 7.80459899,55.1112817 C8.94579899,56.1573817 10.023599,57.3619817 10.689299,58.9152817 C11.037999,59.7077817 11.196499,60.6270817 11.196499,61.6731817 C11.196499,65.2552817 9.42129899,67.2523817 5.99769899,67.2523817 C2.57409899,67.2523817 0.798898993,65.2552817 0.798898993,61.6731817 L0.798898993,60.3100817 L4.09569899,60.3100817 L4.09569899,61.8950817 C4.09569899,63.5117817 4.79309899,64.0506817 5.90259899,64.0506817 C7.01209899,64.0506817 7.70949899,63.5117817 7.70949899,61.8950817 C7.70949899,60.3734817 6.94869899,59.2639817 5.93429899,58.2178817 C5.42709899,57.7106817 4.88819899,57.2034817 4.31759899,56.6645817 C3.14469899,55.6501817 2.06689899,54.4455817 1.40119899,52.8922817 C1.05249899,52.0997817 0.893998993,51.1804817 0.893998993,50.1343817 Z M12.7640618,66.9987817 L12.7640618,44.8087817 L16.2510618,44.8087817 L16.2510618,66.9987817 L12.7640618,66.9987817 Z M18.3575246,66.9987817 L18.3575246,44.8087817 L23.8733246,44.8087817 C27.3920246,44.8087817 29.0721246,46.7107817 29.0721246,50.2928817 L29.0721246,61.5146817 C29.0721246,65.0967817 27.3920246,66.9987817 23.8733246,66.9987817 L18.3575246,66.9987817 Z M23.8099246,47.9787817 L21.8445246,47.9787817 L21.8445246,63.8287817 L23.8099246,63.8287817 C24.9194246,63.8287817 25.5851246,63.2898817 25.5851246,61.6731817 L25.5851246,50.1343817 C25.5851246,48.5176817 24.9194246,47.9787817 23.8099246,47.9787817 Z M34.3485875,47.9787817 L34.3485875,54.1602817 L39.1352875,54.1602817 L39.1352875,57.3302817 L34.3485875,57.3302817 L34.3485875,63.8287817 L40.3715875,63.8287817 L40.3715875,66.9987817 L30.8615875,66.9987817 L30.8615875,44.8087817 L40.3715875,44.8087817 L40.3715875,47.9787817 L34.3485875,47.9787817 Z M46.5816131,66.9987817 L46.5816131,44.8087817 L50.0686131,44.8087817 L50.0686131,66.9987817 L46.5816131,66.9987817 Z M60.1317759,66.9987817 L56.7398759,58.1544817 L55.6620759,60.1832817 L55.6620759,66.9987817 L52.1750759,66.9987817 L52.1750759,44.8087817 L55.6620759,44.8087817 L55.6620759,54.4772817 L60.2268759,44.8087817 L63.7138759,44.8087817 L58.8637759,54.6991817 L63.7138759,66.9987817 L60.1317759,66.9987817 Z M72.8260388,66.9987817 L69.4341388,58.1544817 L68.3563388,60.1832817 L68.3563388,66.9987817 L64.8693388,66.9987817 L64.8693388,44.8087817 L68.3563388,44.8087817 L68.3563388,54.4772817 L72.9211388,44.8087817 L76.4081388,44.8087817 L71.5580388,54.6991817 L76.4081388,66.9987817 L72.8260388,66.9987817 Z M81.0506016,47.9787817 L81.0506016,54.1602817 L85.8373016,54.1602817 L85.8373016,57.3302817 L81.0506016,57.3302817 L81.0506016,63.8287817 L87.0736016,63.8287817 L87.0736016,66.9987817 L77.5636016,66.9987817 L77.5636016,44.8087817 L87.0736016,44.8087817 L87.0736016,47.9787817 L81.0506016,47.9787817 Z M96.7706272,47.9787817 L96.7706272,54.6674817 L101.272027,54.6674817 L101.272027,57.8374817 L96.7706272,57.8374817 L96.7706272,66.9987817 L93.2836272,66.9987817 L93.2836272,44.8087817 L102.508327,44.8087817 L102.508327,47.9787817 L96.7706272,47.9787817 Z M103.60039,44.8087817 L107.08739,44.8087817 L107.08739,61.9267817 C107.08739,63.5434817 107.78479,64.0823817 108.89429,64.0823817 C110.00379,64.0823817 110.70119,63.5434817 110.70119,61.9267817 L110.70119,44.8087817 L113.99799,44.8087817 L113.99799,61.7048817 C113.99799,65.2869817 112.22279,67.2840817 108.79919,67.2840817 C105.37559,67.2840817 103.60039,65.2869817 103.60039,61.7048817 L103.60039,44.8087817 Z M123.395453,66.9987817 L119.052553,50.9268817 L119.052553,66.9987817 L115.914253,66.9987817 L115.914253,44.8087817 L120.288853,44.8087817 L123.870953,58.0910817 L123.870953,44.8087817 L126.977553,44.8087817 L126.977553,66.9987817 L123.395453,66.9987817 Z M136.501816,66.9987817 L132.158916,50.9268817 L132.158916,66.9987817 L129.020616,66.9987817 L129.020616,44.8087817 L133.395216,44.8087817 L136.977316,58.0910817 L136.977316,44.8087817 L140.083916,44.8087817 L140.083916,66.9987817 L136.501816,66.9987817 Z M145.645679,47.9787817 L145.645679,54.1602817 L150.432379,54.1602817 L150.432379,57.3302817 L145.645679,57.3302817 L145.645679,63.8287817 L151.668679,63.8287817 L151.668679,66.9987817 L142.158679,66.9987817 L142.158679,44.8087817 L151.668679,44.8087817 L151.668679,47.9787817 L145.645679,47.9787817 Z M152.380341,47.9787817 L152.380341,44.8087817 L163.158341,44.8087817 L163.158341,47.9787817 L159.512841,47.9787817 L159.512841,66.9987817 L156.025841,66.9987817 L156.025841,47.9787817 L152.380341,47.9787817 Z"
                  id="Side-ikke-funnet"
                ></path>
              </g>
              <polyline
                id="Fill-34"
                fill="#DABCD0"
                points="131.937 176.458 129.511 162.865 143.504 176.458 131.937 176.458"
              ></polyline>
              <polyline
                id="Fill-35"
                fill="#FFF0F6"
                points="306.355 313.163 306.355 267.555 353.282 267.555 349.642 314.718 306.355 313.163"
              ></polyline>
              <polyline
                id="Fill-36"
                fill="#FFF0F6"
                points="144.54 205.363 143.504 188.021 180.811 188.021 179.117 206.4 144.54 205.363"
              ></polyline>
              <polygon
                id="Fill-37"
                fill="#FFF0F6"
                points="154.502 282.14 170.716 282.14 170.716 269.493 154.502 269.493"
              ></polygon>
              <polygon
                id="Fill-38"
                fill="#FFF0F6"
                points="175.612 282.14 191.827 282.14 191.827 269.493 175.612 269.493"
              ></polygon>
              <polygon
                id="Fill-39"
                fill="#FFF0F6"
                points="154.502 298.725 170.716 298.725 170.716 286.078 154.502 286.078"
              ></polygon>
              <polygon
                id="Fill-40"
                fill="#FFF0F6"
                points="175.612 298.725 191.827 298.725 191.827 286.078 175.612 286.078"
              ></polygon>
            </g>
          </g>
        </svg>
      </div>

      <router-link to="/" class="btn button--primary"
        >Gå til forsiden</router-link
      >
    </div>
  </article>
</template>

<script>
import PageLogo from "@/components/blocks/PageLogo";

export default {
  name: "page404",
  components: {
    PageLogo
  },
  beforeMount() {
    jQuery("html").addClass("is_404");
  },
  beforeDestroy() {
    jQuery("html").removeClass("is_404");
  },
  mounted() {},

  computed: {},
  methods: {}
};
</script>

<style lang="scss">
html.is_404 {
}
.page_404 {
  text-align: center;
  padding-top: 60px;
  padding-bottom: 85px;
  .btn {
    display: inline-block;
    margin-top: 50px;
    background: #7a0052;
    transition: 0.2s ease-in-out;
    &:hover {
      color: #fff;
      background-color: #fd2175;
    }
  }
  .no-found-icon {
    svg {
      overflow: visible;
      #sign {
        transform: rotate(-8deg) translate(0, 20px);
        transform-origin: 21% 65%;
        animation: waveSign 5s infinite;
        animation-timing-function: ease-in-out;
      }
    }
  }
}
@keyframes waveSign {
  0% {
    transform: rotate(-8deg) translate(0, 20px);
  }

  50% {
    transform: rotate(28deg) translate(0, 20px);
  }
  100% {
    transform: rotate(-8deg) translate(0, 20px);
  }
}
</style>
